import axios from "axios";

export const API_BASE = "https://api.dairycrm.in";

const axiosInstance = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
  // timeout: 15000,
});

// -------------------- REQUEST --------------------
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
  
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// -------------------- RESPONSE --------------------
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
console.log(error)

    // 🌐 Network / CORS / server down
    if (!error.response) {
      alert("Network error. Please check your internet connection.");
      return Promise.resolve(null); // ✅ stop React error
    }

    const { status, data } = error.response;

    // 🔐 Unauthorized
    if (status === 401) {
      alert("Session expired. Please login again.");
      localStorage.removeItem("auth_token");
      window.location.href = "/login";
      return Promise.resolve(null);
    }

    // ❌ Validation / bad request
    if (status === 400) {
      alert(data?.message || "Invalid request.");
      return Promise.resolve(null); // ✅ IMPORTANT
    }

    // 💥 Server error
    if (status >= 500) {
      alert("Server error. Please try again later.");
      return Promise.resolve(null);
    }

    // ❗ Unknown error (rare)
    return Promise.reject(error); // let dev see it
  }
);

export default axiosInstance;
